import { Slot } from 'expo-router';

export default function NotificationsLayout(): React.ReactNode {
  return <Slot />;
}
